import React from 'react';
import { useNavigate } from 'react-router-dom';

const Goal3 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/#sdg-goals');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <button
        onClick={handleGoBack}
        className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </button>
      <h2 className="text-3xl font-bold mb-4">SDG 3 Good Health and Well-being</h2>
      <p className="text-lg mb-4">
        Ensure healthy lives and promote well-being for all at all ages.
      </p>
      <a
        href="https://sdg-tracker.org/good-health"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        https://sdg-tracker.org/good-health
      </a>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Targets</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.1</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Reduce maternal mortality</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, reduce the global maternal mortality ratio to less than 70 per 100,000 live births.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.2</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">End all preventable deaths under 5 years of age</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, end preventable deaths of newborns and children under 5 years of age, with all countries aiming to reduce neonatal mortality to at least as low as 12 per 1,000 live births and under-5 mortality to at least as low as 25 per 1,000 live births.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.3</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Fight communicable diseases</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, end the epidemics of AIDS, tuberculosis, malaria and neglected tropical diseases and combat hepatitis, water-borne diseases and other communicable diseases.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.4</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Reduce mortality from non-communicable diseases and promote mental health</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, reduce by one third premature mortality from non-communicable diseases through prevention and treatment and promote mental health and well-being.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.5</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Prevent and treat substance abuse</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Strengthen the prevention and treatment of substance abuse, including narcotic drug abuse and harmful use of alcohol.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.6</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Reduce road injuries and deaths</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, halve the number of global deaths and injuries from road traffic accidents.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.7</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Universal access to sexual and reproductive care, family planning and education</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure universal access to sexual and reproductive health-care services, including for family planning, information and education, and the integration of reproductive health into national strategies and programmes.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.8</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Achieve universal health coverage</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Achieve universal health coverage, including financial risk protection, access to quality essential health-care services and access to safe, effective, quality and affordable essential medicines and vaccines for all.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.9</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Reduce illnesses and deaths from hazardous chemicals and pollution</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, substantially reduce the number of deaths and illnesses from hazardous chemicals and air, water and soil pollution and contamination.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.A</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Implement the WHO framework convention on tobacco control</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Strengthen the implementation of the World Health Organization Framework Convention on Tobacco Control in all countries, as appropriate.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.B</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Support research, development and universal access to affordable vaccines and medicines</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Support the research and development of vaccines and medicines for the communicable and noncommunicable diseases that primarily affect developing countries, provide access to affordable essential medicines and vaccines, in accordance with the Doha Declaration on the TRIPS Agreement and Public Health, which affirms the right of developing countries to use to the full the provisions in the Agreement on Trade Related Aspects of Intellectual Property Rights regarding flexibilities to protect public health, and, in particular, provide access to medicines for all.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.C</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Increase health financing and support health workforce in developing countries</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Substantially increase health financing and the recruitment, development, training and retention of the health workforce in developing countries, especially in least developed countries and small island developing States.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">3.D</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Improve early warning systems for global health risks</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Strengthen the capacity of all countries, in particular developing countries, for early warning, risk reduction and management of national and global health risks.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Goal3;
